import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'
import Vue from "vue";

export default [
  // ===
  // 會員中心
  // ===
  {
    path: '/shop/member',
    name: 'shop-member',
    component: () => lazyLoadView(import('@views/Wordpress/Member/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const memberInfo = await store.dispatch('wordpress/fetchMember');
          routeTo.params.memberInfo = memberInfo;
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginWordpressPage: true,
      showRightToolBox: false,
    },
    props: (route) => ({
      memberInfo: route.params.memberInfo || {},
    }),
  },
  // ===
  // 我的購物
  // ===
  {
    path: '/shop/member/shopping',
    name: 'shop-member-shopping',
    component: () => lazyLoadView(import('@views/Wordpress/Member/OrderList.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginWordpressPage: true,
      showRightToolBox: false,
    }
  },
  // ===
  // 我的購物 內容頁
  // ===
  {
    path: '/shop/member/shopping/:orderId',
    name: 'shop-member-shopping-item',
    component: () => lazyLoadView(import('@views/Wordpress/Member/OrderItem.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrderItem
          ] = await Promise.all([
            store.dispatch('wordpress/fetchOrderItem', {
              id: routeTo.params.orderId
            }),
          ]);

          routeTo.params.orderItem = currentOrderItem;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginWordpressPage: true,
      showRightToolBox: false,
    },
    props: (route) => ({
      orderItem: route.params.orderItem || {},
    }),
  },
  // ===
  // 會員設定
  // ===
  {
    path: '/shop/member/info',
    name: 'shop-member-info',
    component: () => lazyLoadView(import('@views/Wordpress/Member/Info.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const memberInfo = await store.dispatch('wordpress/fetchMember');
          routeTo.params.memberInfo = memberInfo;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginWordpressPage: true,
      showRightToolBox: false,
    },
    props: (route) => ({
      memberInfo: route.params.memberInfo || {},
    })
  },
  // ===
  // 會員專區
  // ===
  {
    path: '/shop/member/membership',
    name: 'shop-member-membership',
    component: () => lazyLoadView(import('@views/Wordpress/Member/Membership.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const membershipInfo = await store.dispatch('wordpress/fetchMembership');
          routeTo.params.membershipInfo = membershipInfo;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginWordpressPage: true,
      showRightToolBox: false,
    },
    props: (route) => ({
      membershipInfo: route.params.membershipInfo || {},
    })
  },
  // ===
  // 地址簿
  // ===
  {
    path: '/shop/member/address',
    name: 'shop-member-address',
    component: () => lazyLoadView(import('@views/Wordpress/Member/Address.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const memberInfo = await store.dispatch('wordpress/fetchMember');
          routeTo.params.memberInfo = memberInfo;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginWordpressPage: true,
      showRightToolBox: false,
    },
    props: (route) => ({
      memberInfo: route.params.memberInfo || {},
    }),
  },
  // ===
  // 發票資訊
  // ===
  {
    path: '/shop/member/invoice',
    name: 'shop-member-invoice',
    component: () => lazyLoadView(import('@views/Wordpress/Member/Invoice.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const invoiceInfo = await store.dispatch('wordpress/fetchMemberInvoice');
          routeTo.params.invoiceInfo = invoiceInfo;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginWordpressPage: true,
      showRightToolBox: false,
    },
    props: (route) => ({
      invoiceInfo: route.params.invoiceInfo || {},
    }),
  },
  // ===
  // 捲粉點數
  // ===
  {
    path: '/shop/member/point',
    name: 'shop-member-point',
    component: () => lazyLoadView(import('@views/Wordpress/Member/PointList.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginWordpressPage: true,
      showRightToolBox: false,
    }
  },
  // ===
  // 購物折價券
  // ===
  {
    path: '/shop/member/coupon',
    name: 'shop-member-coupon',
    component: () => lazyLoadView(import('@views/Wordpress/Member/CouponList.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginWordpressPage: true,
      showRightToolBox: false,
    }
  },
]
